import React from "react";
import { PreviewsLeftCardProps } from "interfaces/previews_left_card.interface";
import { STRINGS } from "constants/strings.constant";
import "./previews_left_card.ui.scss";

// One meter segment per preview up to this many; a larger cap (the backend's is 50) scales down so each segment
// stands for several previews and the meter keeps a constant width.
const MAX_METER_SEGMENTS = 10;

const PreviewsLeftCard = (props: PreviewsLeftCardProps): React.ReactElement => {
  const { remaining, max, className } = props;
  const segments = Math.min(max, MAX_METER_SEGMENTS);
  // A segment stays lit while any preview of its share is left.
  const litSegments = max > 0 ? Math.ceil((Math.max(remaining, 0) / max) * segments) : 0;

  return (
    <div
      className={className ? `previews_left_card ${className}` : "previews_left_card"}
      role="status"
      aria-label={STRINGS.ar.previewsLeft(remaining, max)}
    >
      <div className="previews_left_card_label">{STRINGS.ar.previewsLabel}</div>
      <div className="previews_left_card_count">
        {remaining}
        <span className="previews_left_card_of">{STRINGS.ar.previewsOfLeft(max)}</span>
      </div>
      <div className="previews_left_card_meter">
        {Array.from({ length: segments }, (_, index) => (
          <span
            key={index}
            className={index < litSegments ? "previews_left_card_seg" : "previews_left_card_seg previews_left_card_seg_used"}
          />
        ))}
      </div>
    </div>
  );
};

export default PreviewsLeftCard;
